import { List, Popup, Spacing, Text } from '@approvalmax/ui/src/components';

import { messages } from './OwnershipExplanationPopup.messages';
import image from './ownershipt-explanation.png';

export const OwnershipExplanationPopup = () => {
    return (
        <>
            <Popup.Header title={messages.title} />

            <Popup.Body spacing='20 32 32 32'>
                <Text font='body' fontSize='medium'>
                    {messages.inTheExample}
                </Text>

                <br />

                <Text font='body' fontSize='medium'>
                    {messages.weWouldNotNeed}
                </Text>

                <List listStyle='inside'>
                    <List.Item>{messages.lineOne}</List.Item>

                    <List.Item>{messages.lineTwo}</List.Item>

                    <List.Item>{messages.lineThree}</List.Item>
                </List>

                <Spacing height={24} />

                <img src={image} alt='ownership explanation' />
            </Popup.Body>
        </>
    );
};

OwnershipExplanationPopup.displayName = 'OwnershipExplanationPopup';
